import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { Program } from '../interfaces/Program';

export async function getPrograms(): Promise<StandardResponse<Program[]>> {
    const response: AxiosResponse<StandardResponse<Program[]>> = await api.get("/programs");
    return response.data;
}